export default __webpack_public_path__ + "static/media/doctor-1.bf5d223b.jpg";